import { gettext } from '@eventbrite/i18n';

export const BASE_URL = '/attendee-refund-request/';

// Errors

export const STANDARD_SERVER_ERROR = gettext(
    'There was an issue with the server, try again',
);
export const ORDER_ID_INVALID_ERROR = gettext(
    'The Order ID provided does not exist.',
);
export const EMAIL_ADDRESS_INVALID_ERROR = gettext(
    'The email address provided is not valid.',
);

// Refunds form
export const REFUND_REQUESTS_FORM = 'refundsForm';
export const EMAIL_INPUT_LABEL = gettext('Email address');
export const ORDER_ID_INPUT_LABEL = gettext('Order ID');
export const ADDITIONAL_INFO_INPUT_LABEL = gettext('Additional information');
export const ADDITIONAL_INFO_INPUT_PLACEHOLDER = gettext(
    "Provide any additional information you'd like to share about your refund",
);
export const NEW_ADDITIONAL_INFO_INPUT_PLACEHOLDER = gettext(
    'Provide additional information about the event cancelation or postponement to help with Eventbrite’s review.',
);

export const SUBMIT_INPUT_LABEL = gettext('Request a refund');
export const EMAIL_INPUT_ANNOTATION = gettext(
    'The email you placed your order with',
);
export const ADDITIONAL_INFO_INPUT_ANNOTATION = gettext(
    "Any details about the event cancellation that you'd like to share",
);
export const ATTENDEE_REFUND_FORM_TITLE = gettext('Submit a refund request');
export const ATTENDEE_REFUND_CONDTIONS_TITLE = gettext(
    "You may be eligible for a refund if you're submitting your request within 45 days of the event being cancelled (not postponed or rescheduled).",
);

// Actions Names
export const INITIALIZE_APP = 'attendee-refund-request/INITALIZE_APP';

// Refund Status
export const NEW_REFUND_SUCCESS = 'REFUND_CREATED';
export const REFUND_ALREADY_EXISTS = 'REFUND_DUPLICATED';
export const REFUND_COMPLETED = 'REFUND_COMPLETED';
export const REFUND_VOIDED = 'REFUND_VOIDED';
export const REFUND_REQUEST_INVALID = 'BAD_REQUEST';
export const REFUND_ORDER_NOT_FOUND = 'ORDER_NOT_FOUND';
export const REFUND_ORDER_IS_FREE = 'ORDER_IS_FREE';
export const REFUND_ORDER_IS_NOT_EPP = 'ORDER_IS_NOT_EPP';
export const REFUND_ORDER_TRANSFERRED = 'ORDER_TRANSFERRED';
export const REFUND_ORDER_EMAIL_DOES_NOT_MATCH = 'EMAIL_DOES_NOT_MATCH';
export const REFUND_ORDER_ABANDONED = 'ORDER_ABANDONED';
export const REFUND_ORDER_GATED = 'ORDER_GATED';
export const REFUND_ORDER_DELETED = 'ORDER_DELETED';
export const REFUND_CAPTCHA_ERROR = 'RECAPTCHA_ERROR';
export const REFUND_CAPTCHA_FAILED = 'RECAPTCHA_FAILED';
export const REFUND_CREDIT_CARD_DETECTED = 'CREDIT_CARD_DETECTED';
export const NEW_ORGANIZER_REFUND_POLICY_REQS_LINK =
    'https://www.eventbrite.com/support/articles/en_US/Troubleshooting/eventbrites-organizer-refund-policy-requirements';
export const NEW_REFUND_ELIGIBILITY_LINK =
    'https://www.eventbrite.com/support/articles/en_US/How_To/can-i-get-a-refund?lg=en_US';

// Credit card validation regex
export const CREDIT_CARD_REGEX = new RegExp(
    /(4[0-9]{12}(?:[0-9]{3})?)|((?:5[1-5][0-9]{2}|222[19]|22[39][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|(6(?:011|5[0-9]{2})[0-9]{12})|((?:2131|1800|35d{3})d{11})/,
);
export const ATTENDEE_REFUND_REQUEST_API_KEY_CONFIG = {
    prodKey: '',
    stageKey: '',
    qaKey: '',
    devKey: '',
};
